module.exports = __webpack_public_path__ + "static/media/Grandsquare-Int-Cam-01.9b1cc5e1.webp";